export const ExcludeElement =  ()=>{
    return (
        <div className="container">
            カードの条件から除外する<a href="/tcgcreatoreternalbetaver2/card_variable">カード変数</a>を表します。下記例ではカード効果の主体であるtriggerが除外されます
            <p><img src={`${process.env.PUBLIC_URL}/dialogbox_exclude.png`}></img></p>

        </div>
    )
}
